var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.636 16.3639C7.10845 17.8364 9.04594 18.7527 11.1183 18.9567C13.1906 19.1607 15.2696 18.6398 17.0009 17.4827C18.7322 16.3256 20.0087 14.604 20.6129 12.6112C21.217 10.6184 21.1115 8.47776 20.3142 6.55408C19.5169 4.63039 18.0772 3.0427 16.2404 2.06158C14.4037 1.08045 12.2835 0.766604 10.2413 1.17352C8.19909 1.58043 6.36116 2.68293 5.04073 4.29312C3.72031 5.90332 2.99909 7.92157 3 10.0039V11.9999",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10L3 12L5 10M11 6V11H16",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.efa8eae13c5e6c9509f1e95d18a08f7e.svg";
export { ForwardRef as ReactComponent };